import { render, staticRenderFns } from "./xbt_investment_fund.vue?vue&type=template&id=0a038115&"
import script from "./xbt_investment_fund.vue?vue&type=script&lang=js&"
export * from "./xbt_investment_fund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports